<template>
    <div class="row">
        <div class="col-12">
            <h5>Pardon the interruption...</h5>

            <p>
                <strong>Your session is about to expire</strong><br />
                Don't worry! We will bring you right back to where you left off.
                To protect your data, though, we need to re-establish your secure session.
            </p>

            <button @click="refreshSession" class="btn btn-primary pmbtn" tabindex="0">Continue Session</button>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'TokenExpiring',        
        analyticsCategory: 'TokenExpiring',
        methods: {
            ...mapActions(['loginRedirect']),
            refreshSession() {
                return this.loginRedirect(encodeURI(window.location.href));
            }
        },
    };
</script>

<style lang="scss" scoped>
</style>